export default __webpack_public_path__ + "static/media/HASSAN_NL_SEQ11.0ced4728.mp3";